import { Favorite, FavoriteBorder } from '@mui/icons-material';
import { FastAverageColor } from 'fast-average-color';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

export default function LastIndications({ item }: any) {
    const { user } = useAuth()

    const navigate = useNavigate()
    // Função para converter hexadecimal para RGB
    function hexToRgb(hex) {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    // Função para escurecer uma cor hexadecimal
    function darkenHexColor(hex, lum) {
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        lum = lum || 0;

        let rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }
        return rgb;
    }
    const [gradientColor, setGradientColor] = useState('transparent');
    const [textColor, setTextColor] = useState('#000000'); // Cor do texto, padrão preto

    useEffect(() => {
        const imageUrl = item?.book.img;
        const fac = new FastAverageColor();

        if (imageUrl) {
            fac.getColorAsync(imageUrl)
                .then(color => {
                    const mainColor = color.hex;
                    const darkColor = darkenHexColor(mainColor, -0.3);

                    setGradientColor(`linear-gradient(to bottom, ${mainColor}, ${darkColor})`);

                    // Calcula a luminosidade da cor principal
                    const rgb = hexToRgb(mainColor);
                    if (rgb) {
                        const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b);
                        // Define a cor do texto: branco para cores escuras, preto para cores claras
                        setTextColor(luminance > 128 ? '#000000' : '#ffffff');
                    }
                })
                .catch(e => {
                    console.error("Erro ao extrair cores da imagem:", e);
                    setGradientColor('transparent');
                    setTextColor('#000000');
                });
        }
    }, [item?.book.img]);
    // console.log("CONTEUDO DO ITEM:", item);
    return (
        <div
            onClick={() => navigate('/indicacoes', { state: true })}
            key={item}
            className="group relative flex flex-col w-full bg-white dark:bg-[#0d2d5f]/30 rounded-[15px] shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 dark:border-slate-800 cursor-pointer"
        >
            {/* 1. CONTAINER DA IMAGEM (Com o gradiente dinâmico) */}
            <div
                className="relative flex justify-center items-center p-6 h-[200px] transition-transform duration-500"
                style={{ background: gradientColor || '#f3f4f6' }}
            >
                <img
                    src={item?.book.img}
                    alt="imagem do livro"
                    className="h-full object-contain z-10 shadow-[0_10px_20px_rgba(0,0,0,0.3)] group-hover:scale-110 transition-transform duration-500 rounded-sm"
                />

                {/* Contador de Likes Estilo Vidro (Badge) */}
                <div className="absolute top-2 right-2 z-50">
                    <div className="flex items-center gap-1 px-2 py-1 bg-white/30 backdrop-blur-md rounded-full border border-white/20 shadow-sm transition-all group-hover:bg-white/70">
                        <span className="text-red-600 flex items-center">
                            {item?.likes > 0 ? <Favorite sx={{ fontSize: 16 }} /> : <FavoriteBorder sx={{ fontSize: 16 }} />}
                        </span>
                        <span className="text-red-600 text-[11px] font-bold">
                            {item?.likes}
                        </span>
                    </div>
                </div>
            </div>

            {/* 2. RODAPÉ DE INFORMAÇÕES (Padronizado) */}
            <div className="p-4 bg-white dark:bg-[#2d3d5780] border-t border-gray-100 dark:border-slate-800 flex flex-col justify-center min-h-[85px]">
                {/* Título com Truncate padrão */}
                <h3
                    className="font-bold text-slate-800 dark:text-white text-sm leading-tight truncate capitalize mb-1"
                    title={item?.book.title}
                >
                    {item?.book.title}
                </h3>

                {/* Autor com estilo sutil */}
                <p
                    className="text-[11px] text-slate-500 dark:text-slate-400 font-medium truncate capitalize tracking-wide"
                    title={item?.book.autor}
                >
                    {item?.book.autor}
                </p>
            </div>
        </div>
    )
}